import { Reveal } from "./Reveal";

export default function SectionHeader({ eyebrow, title, copy, align = "left" }) {
  const alignCls = align === "center" ? "items-center text-center" : "items-start text-left";
  return (
    <Reveal className={`flex max-w-3xl flex-col gap-4 ${alignCls}`}>
      {eyebrow && (
        <span className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-brand">
          {eyebrow}
        </span>
      )}
      <h2 className="font-display text-2xl font-bold leading-snug tracking-tight text-white sm:text-3xl lg:text-4xl">
        {title}
      </h2>
      {copy && <p className="text-base leading-relaxed text-mist sm:text-lg">{copy}</p>}
    </Reveal>
  );
}
